module.exports = __webpack_public_path__ + "img/woocommerce-channel.4910ab5f.png";